import {createSlice,createAsyncThunk} from "@reduxjs/toolkit";

const reportsSlice = createSlice({
    name:'reports', 
    initialState:{ 
        loading: false,
        reports :[],
        report:{}
    },
    reducers:{
        add_reports:(state,action)=>{
            state.reports = action.payload
        },
        add_report:(state,action)=>{
            state.report = action.payload
        },
        delete_reports:(state)=>{
            state.reports = []
        }
    }
})

export const {add_reports,delete_reports,add_report} = reportsSlice.actions;
export default reportsSlice.reducer;